/**
 * Copies `val` to the clipboard (requires `execCommand` support).
 *
 * @param { string } val The value to copy
 * @param { string } success_msg Toastr popup msg on success
 * @param { string } error_msg Toastr popup msg on fail
 */
export async function copyValueToClipboard(val, success_msg, error_msg) {
  const text_area_el = document.createElement(`textarea`);
  text_area_el.value = val;
  // to prevent any scroll behavior
  text_area_el.style.position = `fixed`;
  text_area_el.style.height = `0`;
  text_area_el.style.width = `0`;
  text_area_el.style.top = `0`;
  text_area_el.style.left = `0`;
  document.body.appendChild(text_area_el);
  text_area_el.focus();
  text_area_el.select();
  try {
    document.execCommand("copy");
    toastr.info(success_msg ?? "Copied to clipboard!");
  } catch (err) {
    toastr.error(error_msg ?? `Failed to copy to clipboard.`);
  }
}

export const resolvePlanType = () => window.plan_type_data?.override ?? window.plan_type_data.original;

export function isPodcaster() {
  return resolvePlanType() === 'podcaster';
}

export function isBroadcaster() {
  return resolvePlanType() === 'broadcaster';
}

export function getFeedLabel(uc = false) {
  if (isPodcaster()) {
    return uc ? 'Podcast' : 'podcast';
  }

  return uc ? 'Feed' : 'feed';
}

/**
 * Returns either 'item' or 'episode', depending on the customer's preference.
 * @param { boolean } uc Whether or not to capitalise the first character
 */
export function getItemLabel(uc = false) {
  if (isPodcaster()) {
    return uc ? 'Episode' : 'episode';
  }

  if (!window.preferences) {
    return uc ? 'Item' : 'item';
  }

  if (!window.preferences.item_is_episode) {
    return uc ? 'Item' : 'item';
  }

  return uc ? 'Episode' : 'episode';
}
